import { Fragment, useState, useRef, useEffect, useContext } from "react";
import { TextsContext } from '../context/textsContext';
import { Outlet, useLocation } from "react-router-dom";
import StyleGrid from "../scss/grid.module.scss";
import style from "../scss/formLayout.module.scss";
import { FooterComponent } from "../components/FooterComponent";
import MenuComponent from "../components/MenuComponent";
import StepComponents from "../components/StepComponents";
import { ParagraphComponent } from "../components/ParagraphComponent";
import { TitleH2Component } from "../components/TitleH2Component";
import DialogComponent from "../components/DialogComponent";
import UnsavedChangesModal from "../components/UnsavedChangesModal";

import { isMobileOnly } from "react-device-detect";
import { Icon } from "@iconify/react";

import { useCotizador } from "../context/apiContext";
import { useNavigate } from "react-router-dom";
import { isInFrame } from "../helpers/toolsHelper";
import { useSteps } from "hooks/useSteps";

const QuoterFormLayout = () => {
    const { texts } = useContext(TextsContext);
    const currentPath = window.location.pathname;

    const [, setWindowHeight] = useState(window.innerHeight);

    const hHeader = useRef(null);
    const wpGroup = useRef(null);
    const hContent = useRef(null);
    const hFooter = useRef(null);
    const stepsG = useRef(null);

    const [isFocused, setIsFocused] = useState(false);

    const [disabledHeader, setDisabledHeader] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const { getSteps } = useSteps();
    const { addDependant, hasUnsavedChanges } = useCotizador();

    const currentPathIndex = getSteps(addDependant).find(i => i.path == currentPath)?.index;

    useEffect(() => {
        if (currentPathIndex === undefined) {
            navigate('/step1')
        }
    }, [navigate])


    useEffect(() => {

        if (isInFrame()) {
            localStorage.setItem('onApp', 1);
            setDisabledHeader(true);
        } else {
            if (localStorage.getItem('onApp') == 1) {
                setDisabledHeader(true);
            } else {
                setDisabledHeader(false);
            }
        }
        if (isMobileOnly) {
            const updateWindowHeight = () => {
                setWindowHeight(window.innerHeight);
            };

            //funciones para cuando este en mobile y se haga focus en un input text el wpGroup aunmente,
            //su altura y tenga un mejor espacio para los elementos ya que aparece el teclado 

            const handleGlobalFocus = (event) => {
                if ((event.target.tagName === 'INPUT' && event.target.type === 'text') || event.target.type === 'email') {
                    console.log(`Se seleccionó el elemento: ${event.target.tagName}`);
                    setIsFocused(true);
                    // hContent.current.style.height = `${realHContent+alturaFooter}px`;
                }
            };

            const handleGlobalBlur = (event) => {
                if ((event.target.tagName === 'INPUT' && event.target.type === 'text') || event.target.type === 'email') {
                    console.log(`Se desenfocó el elemento: ${event.target.tagName}`);
                    setIsFocused(false);
                    // hContent.current.style.height = `${realHContent2}px`;
                }
            };

            document.addEventListener('focus', handleGlobalFocus, true);
            document.addEventListener('blur', handleGlobalBlur, true);

            return () => {
                window.removeEventListener('resize', updateWindowHeight);
                document.removeEventListener('focus', handleGlobalFocus, true);
                document.removeEventListener('blur', handleGlobalBlur, true);
            };

        }

    }, [location]);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showBackToHome, setShowBackToHome] = useState(false);

    const handleCloseBackToHome = () => setShowBackToHome(false);
    const handleShowBackToHome = () => setShowBackToHome(true);

    const { resetData } = useCotizador();

    useEffect(() => {
        return () => {
            resetData();
        };
    }, []);

    const reset = () => {
        resetData();
        navigate("/step1");
        handleClose(true);
    }

    const backToHome = () => {
        resetData();
        navigate("/home");
        handleCloseBackToHome();
    }

    // Igual que MyFavoritePlanFormContext.goToDashboard: sin cambios sin guardar
    // se navega directo, sin pedir confirmación.
    const goHome = () => {
        if (hasUnsavedChanges) {
            handleShowBackToHome();
            return;
        }
        navigate("/home");
    }

    return (
        <Fragment>
            <div className={style.wrapper}>
                {!disabledHeader &&
                    <div className={`${style.sidebar} d-none d-lg-flex`} ref={hHeader}>
                        <div className={StyleGrid.wpScroll}>
                            <MenuComponent />
                            <div className={`${StyleGrid.tooltipicon}`}>
                                <div className={`${StyleGrid.text_tooltip} me-2 bg_gray_3 d-flex align-items-center`}>
                                    <ParagraphComponent styleGroup='mb-0 color_gray_5 pb-0'>
                                        {texts?.menu_paragraph ?? 'Place the cursor over the information icon  for further explanation about each one of the fields.'}
                                    </ParagraphComponent>
                                    <div className={`${StyleGrid.iconInfo} color_gray_5 `}>
                                        <Icon icon='mdi:information-symbol' />
                                    </div>
                                </div>

                            </div>

                        </div>
                        <button type="button" className={style.backToHome} onClick={goHome}>
                            {texts?.menu_back_to_home ?? 'Back to Home'}
                        </button>
                    </div>
                }

                <UnsavedChangesModal show={showBackToHome} onConfirm={backToHome} onCancel={handleCloseBackToHome} />

                {disabledHeader &&
                    <button className={`${StyleGrid.NewStart} color_secundary`} onClick={handleShow}>
                        <span>New</span>
                        <Icon icon='ic:outline-plus' />
                    </button>
                }

                <DialogComponent
                    show={show}
                    onClose={handleClose}
                    onCancel={handleClose}
                    onConfirm={reset}
                    cancelText={texts?.modal_boton_closed ?? 'Close'}
                    confirmText={
                        <span className="d-flex justify-content-center align-items-center">
                            <span className="me-2 d-flex"><Icon icon="ei:plus" width={24} height={24} /></span>
                            <span>{texts?.menu_phrase ?? 'Start over with quote'}</span>
                        </span>
                    }
                >
                    <Icon icon="fluent:alert-12-regular" width={40} height={40} style={{ color: '#F12B24' }} className="mb-3" />
                    <TitleH2Component styleGroup="raleway fw_700 color_primary mb-0">
                        {texts?.general_warning_title ?? 'Aviso'}
                    </TitleH2Component>
                </DialogComponent>

                <div className={`${style.content} ${disabledHeader ? StyleGrid.noTop : ''}`} ref={wpGroup}>
                    <div className={`${disabledHeader ? StyleGrid.noTopHeader : ''}`}>
                        <div ref={stepsG}>
                            <div className="d-lg-none">
                                <StepComponents />
                            </div>
                        </div>

                    </div>
                    <div className={`py-3 ${style.contentScroll}`} ref={hContent}>
                        <Outlet />
                    </div>
                    {
                        currentPath !== '/step9' && (
                            <div className={`${style.footer}
                        ${isFocused ? `${StyleGrid.getOut}` : ''} `} ref={hFooter}>
                                <FooterComponent hContent={hContent} />
                            </div>
                        )
                    }
                </div>
            </div>
        </Fragment >
    );
}

export default QuoterFormLayout;